<div class="pt-2">
  <ui-menu [menu]="adminMenu" menuClass="root-menu"></ui-menu>
</div>
